import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrow2 = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 14,
	height: 8,
	viewBox: "0 0 14 8",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M1 1L7 7L13 1",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgArrow2;
